import CircularLoader from "app/components/CircularLoader";
import TicketMentionItem from "app/components/ReplyComment/components/MentionDropdown/components/TicketMentionItem";
import { selectMentionData } from "app/components/ReplyComment/redux/selectors";
import { TicketType } from "app/components/ReplyComment/redux/types";
import React, { UIEvent } from "react";
import { useSelector } from "react-redux";

const RenderTicketItems = ({
  handleTicketSelect,
  handleTicketScroll,
  ticketLoading,
  projectId,
}: {
  projectId: string;
  handleTicketSelect: (ticket: TicketType) => void;
  handleTicketScroll: (e: UIEvent<HTMLDivElement>) => void;
  ticketLoading: boolean;
}) => {
  // Global State
  const mentionData = useSelector(selectMentionData);

  // Variables
  const ticketData = mentionData[projectId as string]?.tickets;

  return (
    <div
      className="flex flex-col overflow-y-auto max-h-[300px]"
      onScroll={handleTicketScroll}
    >
      {ticketLoading && (!ticketData?.list || ticketData.list.length === 0) ? (
        <div className="w-full flex items-center justify-center py-3 h-24">
          <CircularLoader size="md" />
        </div>
      ) : ticketData.list?.length > 0 ? (
        ticketData.list?.map((ticket) => (
          <TicketMentionItem
            key={ticket?._id}
            ticket={ticket}
            onSelect={handleTicketSelect}
          />
        ))
      ) : (
        <div className="px-4 py-8 text-center text-gray-500">
          No tickets found
        </div>
      )}
      {ticketLoading && ticketData.list?.length > 0 && (
        <div className="w-full flex items-center justify-center py-3">
          <CircularLoader size="sm" />
        </div>
      )}
    </div>
  );
};

export default RenderTicketItems;
